import { useState, useEffect } from "react";
import axiosInstance from "../api/axiosInstance";
import { ENDPOINTS } from "../api/endpoints";


export const useDeliveryInstructions = (taskId) => {
  const [instructionList, setInstructionList] = useState([]);
  const [submittedInstruction, setSubmittedInstruction] = useState(null);
  const [existingInstruction, setExistingInstruction] = useState(null);

  //  Fetch instruction list
  const fetchInstructions = async () => {
    const res = await axiosInstance.post(
      ENDPOINTS.DELIVERY_INSTRUCTIONS,
      { status: "Y" }
    );

    if (res?.data?.responseCode === "00") {
      setInstructionList(res.data.data || []);
    }
  };

  //  Fetch already submitted instruction
  const fetchCustomerInstruction = async () => {
    if (!taskId) return;

    const res = await axiosInstance.post(
      ENDPOINTS.GET_CUSTOMER_DELIVERY_INSTRUCTION,
      { taskId }
    );

    if (res?.data?.responseCode === "00") {
      setExistingInstruction(res.data.data?.[0] || null);
    }
  };

  //  Submit instruction
  const submitInstruction = async (payload) => {
    await axiosInstance.post(
      ENDPOINTS.INSERT_INSTRUCTION,
      payload
    );

    setSubmittedInstruction({
      title:
        instructionList.find(
          (i) => i.pk_instruction_id === payload.instructionId
        )?.title || "Custom instruction",
      customerMessage: payload.extraMessege,
    });

    fetchCustomerInstruction();
  };

  useEffect(() => {
  if (taskId) {
    fetchCustomerInstruction();
  }
}, [taskId]);

  return {
    instructionList,
    submittedInstruction,
    existingInstruction,
    fetchInstructions,
    submitInstruction,
  };
};
